import { Fragment } from 'react'

import { Section, SectionList, SubTitle } from '@/components/ArticleElement'
import PoliciesLayout from '@/components/Layouts/PoliciesLayout'
import { useLanguage } from '@/hooks/Contexts'

const TermsOfUse = () => {
  const {
    terms_of_use: { main, titles, paragraphs, lists },
  } = useLanguage()

  return (
    <PoliciesLayout title='terms_of_use'>
      {titles.map((title, i) => (
        <Fragment key={i}>
          {main[i] && <SubTitle extraCls='mt-4 first:mt-0'>{main[i]}</SubTitle>}

          {title && <SubTitle extraCls='mt-4 first:mt-0'>{title}</SubTitle>}

          {paragraphs[i] && <Section paragraphs={paragraphs[i]} paragraphCls='mt-2' />}

          {lists[i] && <SectionList listCls='list-decimal' list={lists[i]} />}
        </Fragment>
      ))}
    </PoliciesLayout>
  )
}

export default TermsOfUse
